import { useTranscription } from "@platform/features/video/providers/TranscriptionProvider";
import VideoMeetingControlsTranscription from "./VideoMeetingControlsTranscription";
import { useVideoRoster } from "@platform/store";

export function VideoMeetingControlsTranscriptionContainer() {
  const { state, toggleTranscription } = useTranscription();

  const roster = useVideoRoster();

  const attendeeCount = Object.keys(roster).length;

  if (state.isTranscriptionDisabled) {
    return null;
  }

  if (attendeeCount <= 1) {
    return null;
  }

  return (
    <VideoMeetingControlsTranscription
      isTranscribing={state.isTranscribing}
      isLoading={state.isLoading}
      onClick={toggleTranscription}
    />
  );
}

export default VideoMeetingControlsTranscriptionContainer;
